import React from "react";

interface BuildingProps {
  name: string;
  size: { width: number; height: number };
  glowColor: string;
  glowSize?: number;
}

/**
 * building image with glow.
 * uses public/heatmapImg/<name>.svg and <name>glow.png
 * glowcolor can be hex or color name (eg "red")
 */
export const Building: React.FC<BuildingProps> = ({
  name,
  size,
  glowColor,
  glowSize,
}) => {
  return (
    <svg
      {...size}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      // filter={"drop-shadow(0px 0px 10px " + glowColor + ")"}
    >
      {/* recolor glow. https://stackoverflow.com/a/75672139 */}
      <defs>
        <filter id="colorMask">
          <feFlood floodColor={glowColor} result="flood" />
          <feColorMatrix
            result="inv"
            in="SourceGraphic"
            type="matrix"
            values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
          />
          <feComposite
            in="inv"
            in2="flood"
            operator="arithmetic"
            k1="1"
            k2="0"
            k3="0"
            k4="0"
          />
        </filter>

        {/* modified from https://stackoverflow.com/questions/34644730/svg-filter-scale */}
        <filter id={"glow" + name} width="200%" height="200%">
          <feOffset dx="0" dy="0" in="SourceAlpha" result="offset" />
          <feFlood floodColor={glowColor} result="color" />
          <feComposite
            operator="in"
            in="color"
            in2="offset"
            result="colorOffset"
          />
          <feGaussianBlur stdDeviation="10" />
          <feComponentTransfer result="colorBlurOffset">
            <feFuncA
              type="table"
              tableValues={Array.from({ length: 100 }, (_, i) =>
                Math.min(Math.ceil(i / 1.5) * 0.025, 1)
              ).join(" ")}
            />
          </feComponentTransfer>
          <feGaussianBlur stdDeviation={glowSize ?? 10} />

          <feMerge>
            <feMergeNode in="colorBlurOffset" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* <image
        href={"../../heatmapImg/" + name + "glow.png"}
        style={{ overflow: "visible", opacity: 0.78 }}
        height={BUILDING_SIZE}
        filter="url(#colorMask)"
        transform={glowTransform}
        // width="335"
        // height="241"
      ></image> */}

      <image
        href={"../../heatmapImg/" + name + ".svg"}
        {...size}
        filter={"url(#glow" + name + ")"}
      />
    </svg>
  );
};
